import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CcdlNavList } from '@cpm-pr1618001/ng-design-lib';
import { HeaderContainerComponent } from '../header/header.container.component';
import { DashboardComponent } from './dashboard.component';
import { DashboardFacade } from './store/facade/dashboard.facade';

@Component({
  selector: 'fm-dashboard',
  standalone: true,
  imports: [CommonModule, DashboardComponent, HeaderContainerComponent],
  templateUrl: './dashboard.container.component.html',
  styleUrl: './dashboard.container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardContainerComponent {
  facade = inject(DashboardFacade);
  navigationList$ = this.facade.dashboardNavigationList$;

  navigationClick(selectedList: CcdlNavList): void {}
}
